export default "__VITE_ASSET__DCfhRFiz__"